import React from "react"
import { Flex, Dropdown, Tag } from "antd"
import { Text } from "ui/Typography"
import { MoreOutlined } from "@ant-design/icons"
import Avatar from "components/common/Avatar"
import { formatPhoneNumber } from "utils/data-formatters"
import { parseStaffName, getStatusConfig, getRoleConfig } from "../utils/staffTableHelpers"
import styles from "../index.module.css"

export const transformStaffToRow = (staffMember, getMenuItems, t) => {
  const { id, name, title, role, phone_number, email, status, avatar, can_edit } = staffMember || {}
  const parsedName = parseStaffName(name)

  const statusConfig = getStatusConfig(status, t)
  const roleConfig = getRoleConfig(role, t)
  const menuItems = getMenuItems(staffMember)

  return {
    key: id,
    can_edit: can_edit || false,
    name: (
      <Flex gap={12} align="center">
        <Avatar
          user={{ first_name: parsedName.first_name, last_name: parsedName.last_name, avatar }}
          size={40}
          border={false}
          fit={false}
        />
        <Text className="ellipsis" title={name} style={{ maxWidth: "140px" }}>
          {name}
        </Text>
      </Flex>
    ),
    title: (
      <Text className="ellipsis" title={title}>
        {title}
      </Text>
    ),
    role: (
      <Tag color={roleConfig?.color} className={styles.roleTag}>
        {roleConfig?.text}
      </Tag>
    ),
    phone: phone_number ? (
      <Text className="ellipsis" title={phone_number}>
        {formatPhoneNumber(phone_number)}
      </Text>
    ) : null,
    email: email ? (
      <Text className="ellipsis" title={email}>
        {email}
      </Text>
    ) : null,
    status: <Tag color={statusConfig.color}>{statusConfig.text}</Tag>,
    actions: menuItems.length > 0 ? (
      <div onClick={(e) => e.stopPropagation()}>
        <Dropdown
          menu={{
            items: menuItems
          }}
          trigger={["click"]}
          placement="bottomRight"
        >
          <MoreOutlined className={styles.moreIcon} />
        </Dropdown>
      </div>
    ) : null
  }
}
